/* ExportAction.js */

"use strict";
const _ = require("lodash");

class ExportAction {
    constructor(logger, gameEditor, activeView, steveIo) {
        this._logger = logger;
        this._activeView = activeView;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this.run = this.run.bind(this);
    }
    async run() {
        let result = [];
        let entityIds = this._activeView.getSelectedCatalogIds();
        if (!_.isEmpty(entityIds)) {
            let entities =
                entityIds &&
                ((this._activeView._pagingCatalogFeed &&
                    entityIds.selectedRows &&
                    this._activeView._pagingCatalogFeed.getCatalogEntitiesById(entityIds.selectedRows)) ||
                    (await this._gameEditor.getCatalogEntitiesById(entityIds)));
            if (!_.isEmpty(entities)) {
                Object.keys(entities).forEach((id) => {
                    result.push(_.omit(entities[id].properties, "latestHaveIChanged"));
                });
            }
            this._fileFactory.saveJsonAsFile(JSON.stringify(result), "CatalogExport-" + new Date().toISOString() + ".json");
            return Promise.resolve();
        }
    }
}
module.exports = ExportAction;

ExportAction.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.activeView", "$teve.io"];

ExportAction.$displayDetails = {
    type: "Action",
    name: "ExportAction",
    icon: "configdrift.export_devices",
    shown: false,
    title: "Export Entries",
    order: 4
};
